// MessageForm
import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';

import {
  iamTyping as threadMessageIAmTyping,
  messageSubmit as threadMessageSubmit,
} from '../redux/actions/threadsAction';
import {
  capture as messageFormCapture,
  reset as messageFormReset,
} from '../redux/actions/messageFormAction';
import { getTranslator } from '../locales';

@connect((Store) => {
  const t = getTranslator();

  return {
    labels : {
      ADD_YOUR_MESSAGE_HERE: t.t('Add your message here…'),
      POST: t.t('Post')
    },
    luser: Store.luser,
    selectedThreadId: Store.threads.selectedThread.id,
    enterKey: Store.settings.enterKey,
    text: Store.messageForm.text[Store.threads.selectedThread.id] || ''
  };
})

export default class MessageForm extends React.Component {
  onTypingMessage(is_typing) {
    this.props.dispatch( threadMessageIAmTyping({
      is_typing,
      thread_id: this.props.selectedThreadId
    }));
  }

  handleSubmit(e) {
    e.preventDefault();
    const text = _.replace(_.trim(this.props.text), /\n{2,}/ig, '\n\n');

    if (!text || text.length > 2000) {
      return;
    }

    this.props.dispatch(threadMessageSubmit({
      threadId: this.props.selectedThreadId,
      author: this.props.luser,
      body: text
    }));

    this.onTypingMessage(false);

    // dispatch reset text
    this.props.dispatch(messageFormReset(null, this.props.selectedThreadId));
  }

  keyDownHandler(e) {
    if (
      (
        this.props.enterKey === 'on' &&
        e.keyCode === 13 &&
        !e.ctrlKey &&
        !e.shiftKey
      ) || (
        this.props.enterKey === 'off' &&
        e.ctrlKey &&
        e.keyCode === 13
      )
    ) {
      e.preventDefault();
      this.handleSubmit(e);
    }
  }

  changeHandler(e) {
    const text = _.replace(
      _.upperFirst(_.trimStart(e.target.value)),
      /\n{2,}/ig, '\n\n'
    );
    this.onTypingMessage((_.trim(text) ? true : false));

    // Dispatch capture message
    this.props.dispatch(messageFormCapture(text, this.props.selectedThreadId));
  }

  render() {
    return(
      <div className='message_form'>
        <form onSubmit={this.handleSubmit.bind(this)}>
          <textarea
            placeholder={this.props.labels.ADD_YOUR_MESSAGE_HERE}
            onKeyDown={this.keyDownHandler.bind(this)}
            onChange={this.changeHandler.bind(this)}
            onBlur={this.onTypingMessage.bind(this, false)}
            value={this.props.text}
            maxLength='2000'
            tabIndex="1"
            spellCheck="true"
            autoCorrect="on"
            required="required"
          />
          <button
            onClick={this.handleSubmit.bind(this)}
            title={this.props.labels.POST}
            className="btn btn-primary btn-round brandedColor_bg brandedColorLight_border">
              <i className='pe-7s-paper-plane'></i>
          </button>
          <input type="submit" className='mobileSubmiter' />
        </form>
        <div className='clear'></div>
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./src/components/MessageForm.jsx